module.exports = __webpack_public_path__ + "static/media/nitecafe_ai.da3c487d.png";